import axios from "axios";

export default {
    getActivityLog: async () => {
        const {data} = await axios.get('/activity_log')
        return data
    }
}
